export const environment = {
  SERVER_URL: `./`,
  production: true,
  VERSION: require('../../package.json').version,
  supportedLocale:['en','zh-TW','zh-CN']
};
